{
  "feedback-internal-success-page": {
    "buttons": {
      "to-salon": "ZUM SALON"
    },
    "text": {
      "thanks": "Vielen Dank für Ihr Feedback",
      "thanks-again": "Ihr Feedback ist sehr wertvoll und hilft uns, unseren Service zu verbessern."
    }
  }
}
